export enum MenuItemType {
    HOME = 0,
    APPOINTMENTS,
    COMPANY_SEARCH,
    DEVICES,
    PROFILE,
    PROJECTS,
    PRODUCTS,
    SHOP,
    SHOP_FABRICS,
    SHOP_SLATS,
    SHOP_BROCHURES,
    SHOP_CART,
    ORDER_HISTORY,
    CONSULTATIONS,
}
